export default __webpack_public_path__ + "static/media/P-V.8c531fda.mp4";